import { product_images } from "../../Assets/Images/Products/productimg";
import { web_images } from "../../Assets/Images/Web_images/Web_images";

export const products_data = [
  
  {
    id:1,
    name: "Square Pipes",
    main_img:web_images.product1,
    header_span: "Precision-Crafted",
    header_p: "Reliable Square Pipe Solutions for Construction & Fabrication",
    header_img:product_images.dpsquare ,
    sub_header:"Precision-Crafted Square Pipes for Every Project",
    description: `At DAV Net Ent, our Square Pipes are 
    the go-to structural solution for projects demanding high strength, excellent 
    stability, and a modern aesthetic. Widely trusted across construction, 
    fabrication, and manufacturing sectors, our SHS pipes offer an optimal 
    balance of structural integrity and material efficiency.`,

    img1:product_images.dpsquare1,
    img2:product_images.dpsquare2,
    options: [
      {head:"Superior Structural Strength: ",
        detail:`The uniform square cross-section provides exceptional 
        resistance to bending, compression, and torsion (twisting), making 
        it ideal for columns and load-bearing applications.
      `},
      {head:"Cost and Weight Efficiency: ",
        detail:`The hollow profile achieves significant strength with 
        reduced material mass, resulting in a high strength-to-weight ratio that 
        lowers material costs and 
        simplifies transport and installation.
      `},
      {head:"Aesthetic Versatility:  ",
        detail:`The sharp, clean lines of our square sections are 
        perfectly suited for visible applications, from architectural 
        facades and decorative railings to modern furniture frames.
      `}
    ]
  },


  
  
  {
    id:2,
    name: "Galvanized Pipes",
    main_img:web_images.product2,
    header_span: "Explore Our Range of",
    header_p: "Your Source for Long-Lasting Pipe Solutions",
    header_img:product_images.dppipe ,
    sub_header:"Galvanized Pipes That Endure",
    description: `Our Galvanized Pipes  are engineered 
    to deliver maximum longevity and reliability in the most challenging 
    environments. These pipes are the premium choice when steel strength must 
    be combined with superior 
    resistance to weather, moisture, and rust.`,

    img1:product_images.dppipe1,
    img2:product_images.dppipe2,
    options: [
      {head:"Sacrificial Protection:  ",
        detail:`The zinc coating actively corrodes before the underlying steel, 
        providing continuous, long-term protection, even 
        if the surface is scratched or damaged.
      `},
      {head:"Extended Lifespan: ",
        detail:`Our pipes offer a service life that can span decades, 
        significantly lowering your total project costs by 
        minimizing maintenance and replacement cycles.
      `},
      {head:"High Structural Integrity:  ",
        detail:`Provides the inherent load-bearing strength of steel,
         capable of withstanding high pressure and physical stress.
      `}
    ]
  },




   {
    id:3,
    name: "Angle Bars",
    main_img:web_images.product3,
    header_span: "Reliable Solutions for",
    header_p: "Versatile Angle Bars for Industrial & Commercial Use.",
    header_img:product_images.dpangle ,
    sub_header:"Dav-Net Angle Bars: Sharp Lines. Solid Backbone.",
    description: `DAV Net Ent supplies high-quality Steel Angle Bars, often 
    referred to as L-brackets or Angle Iron. These structural profiles are one 
    of the most versatile and essential components in construction and fabrication,
     providing superior support, rigidity, and bracing across a vast range of 
     applications.`,

    img1:product_images.dpangle1,
    img2:product_images.dpangle2,
    options: [
      {head:"High Strength-to-Weight Ratio:  ",
        detail:`Provides significant structural support without adding 
        excessive weight to 
        the overall construction.
      `},
      {head:"Exceptional Versatility: ",
        detail:`The simple 'L' shape is easy to cut, drill, punch, and readily 
        accepts welding and bolting for fast assembly.
      `},
      {head:"Load Distribution:  ",
        detail:`Excellent for bearing weight and distributing loads 
        evenly across two perpendicular planes.
      `}
    ]
  },






     {
    id:4,
    name: "Flat Bars",
    main_img:web_images.product4,
    header_span: "Precision-Cut",
    header_p: "Reliable Flat Bar Solutions for Structural & Decorative Use.",
    header_img:product_images.dpflat ,
    sub_header:"Flat Bars That Deliver Strength and Simplicity.",
    description: `Looking for precision, versatility, and cost-effective strength?
     At DAV Net Ent, our Flat Bar Steel is the essential, solid rectangular section that underpins construction, fabrication, and manufacturing excellence. 
    It's the simple profile that delivers powerful performance.`,

    img1:product_images.dpflat1,
    img2:product_images.dpflat2,
    options: [
      {head:"Versatility & Adaptability:  ",
        detail:` It is the most flexible profile available, perfect for 
        manufacturing everything from heavy brackets and base plates 
        to custom fencing, railings, and ornamental work.
      `},
      {head:"Cost-Effective Strength: ",
        detail:`Provides significant structural support and durability while 
        remaining one of the most cost-effective steel 
        sections, protecting your budget.
      `},
      {head:"Exceptional Weldability:  ",
        detail:`Our Mild Steel grade ensures strong, reliable welds every time, reducing the risk of failure 
        and speeding up your assembly process.
      `}
    ]
  },





    {
    id:5,
    name: "Steel Plates",
    main_img:web_images.product5,
    header_span: "Industrial-Grade",
    header_p: "Reliable Steel Plate Solutions for Construction & Manufacturing.",
    header_img:product_images.dpsteel ,
    sub_header:"Steel Plates That Hold Their Ground",
    description: `When your project demands a material that offers
     maximum durability, superior impact resistance, and vast surface area, 
     you need Steel Plate from DAV Net Ent. As one of the most fundamental products in construction and manufacturing, our steel plates provide the integrity and reinforcement your heavy-duty 
    applications require.`,

    img1:product_images.dpsteel1,
    img2:product_images.dpsteel2,
    options: [
      {head:"Unmatched Load-Bearing Strength:   ",
        detail:` Our plates are the go-to choice for heavy structural 
        foundations, machinery bases, and bridge components, offering phenomenal 
        resistance to force and impact.
      `},
      {head:"Corrosion Protection Options: ",
        detail:`We offer plating in grades suitable for exposed environments, 
        or we can provide galvanizing services to protect your plates 
        against rust and elemental damage.
      `},
      {head:"Reliable Stock & Supply:  ",
        detail:`Our extensive inventory means we can quickly fulfill orders for 
        various thicknesses and sizes, ensuring your project timeline remains on track 
        with guaranteed delivery reliability.
      `}
    ]
  },





  
    {
    id:6,
    name: "Ballustrade Designs",
    main_img:web_images.product6,
    header_span: "Steel & Custom",
    header_p: "Reliable Balustrade Solutions for Homes, Offices & Commercial Spaces",
    header_img:product_images.dptrade ,
    sub_header:"Balustrade Designs for Safety, Style & Structure",
    description: `A balustrade isn't just a safety barrier—it's a critical 
    architectural statement. At DAV Net Ent Metals, 
    we don't just supply material; we fabricate customized balustrade systems 
    that perfectly blend safety, durability, and stunning aesthetics for both 
    interior and exterior applications.`,

    img1:product_images.dptrade1,
    img2:product_images.dptrade2,
    options: [
      {head:"Custom Design & Consultation: ",
        detail:` Our experts work with you to choose the perfect material, 
        infill, and finish to match your 
        specific vision and architectural style.
      `},
      {head:"Safety Compliance: ",
        detail:` Every design is engineered to meet or exceed local 
        building codes and load requirements, 
        ensuring maximum safety and peace of mind.
      `},
      {head:"Superior Materials:  ",
        detail:`We use only premium-grade materials, including Stainless 
        Steel (SS) for sleek, modern looks and ultimate corrosion resistance, and Mild Steel (MS) that
         can be customized with durable coatings.
      `}
    ]
  },





      {
    id:7,
    name: "Welded Mesh",
    main_img:web_images.product7,
    header_span: "Secure & Versatile ",
    header_p: "Welded Mesh That Holds Its Shape—and Your Boundaries",
    header_img:product_images.dpmesh ,
    sub_header:"Reliable Mesh Solutions for Fencing, Reinforcement & Fabrication",
    description: `When you need a material that provides consistent strength, 
    high visibility, and easy fabrication, choose Welded Mesh from DAV Net Ent
     Metals. This versatile product is created by welding intersecting wires at 
     every joint, forming a strong, uniform grid structure that is superior 
    to woven mesh in rigidity and durability.`,

    img1:product_images.dpmesh1,
    img2:product_images.dpmesh2,
    options: [
      {head:"Superior Rigidity: ",
        detail:` Unlike woven wire, the welded structure holds its shape perfectly, 
        making it easier to handle, cut, and install without distortion.
      `},
      {head:"Optimal Strength-to-Weight: ",
        detail:`  Provides significant security and reinforcement without the 
        excessive mass of solid materials.
      `},
      {head:"High Visibility:  ",
        detail:`The clean, square or rectangular apertures allow for excellent light penetration and 
        visual security monitoring.
      `}
    ]
  },





  
      {
    id:8,
    name: "Roofing Sheets",
    main_img:product_images.dpsheet1,
    header_span: "Quality ",
    header_p: "Ultimate in Protection and Style.",
    header_img:product_images.dpsheet ,
    sub_header:"Stop worrying about your roof.",
    description: `At Dav Net Ent, we supply premium roofing sheets
     engineered to deliver a perfect blend of security, longevity, and 
     exceptional value.Our sheets are meticulously crafted to outperform traditional materials, providing peace of mind and superior aesthetics.
      Protect your investment with a roof designed not just to cover, 
    but to endure decades of extreme weather.`,

    img1:product_images.dpsheet1,
    img2:product_images.dpsheet2,
    options: [
      {head:"Extreme Protection: ",
        detail:` Constructed from high-tensile [Material, e.g., Aluzinc Coated Steel] to resist 
        cracking, warping, and bending.
      `},
      {head:"Corrosion Defense: ",
        detail:`  Features a specialized [e.g., AZ150 / Anti-Corrosive] 
        coating that ensures decades of rust-free performance.
      `},
      {head:"Fast Installation:  ",
        detail:`Lightweight yet incredibly strong, our sheets are designed for quick handling, reducing labor time and installation costs.
      `}
    ]
  },


   {
    id:9,
    name: "Twisted Steel Bar",
    main_img:web_images.product9,
    header_span: "Superior",
    header_p: "Strength Meets Style",
    header_img:product_images.dptwist ,
    sub_header:"Twisted Steel Bar",
    description: `Davnet Ent Twisted Steel Bar is the ultimate
     choice for projects demanding both structural integrity and 
     premium aesthetic appeal. Unlike standard rebar, our bars undergo 
     a precise twisting process, enhancing both their strength and their 
     visual impact. 
    Use them to transform simple structures into statement pieces.`,

    img1:product_images.dptwist1,
    img2:product_images.dptwist2,
    options: [
      {head:"Enhanced Strength:: ",
        detail:`The specialized twisting process significantly increases tensile 
        strength for superior load-bearing capacity.
      `},
      {head:"Ornamental Finish: ",
        detail:`Provides a classic, textured, wrought-iron look, perfect 
        for decorative and architectural elements.
      `},
      {head:"Ready Inventory:  ",
        detail:`Stocked in various dimensions and ready for quick 
        supply for your project timelines.
      `}
    ]
  }




  // Add more products as needed
];